import { init } from '@elastic/apm-rum'

export const apmRumInit = (): void => {
  const apm = init(globalThis.apmRumConfig)

  apm.addFilter((payload) => {
    if (payload.errors.length > 0) {
      payload.errors = payload.errors.filter(
        (error) =>
          // The code is bundled and no inline scripts are used
          error.culprit !== '(inline script)' &&
          // Safari does not seem to provide any helpful info on window.onerror
          // https://bugs.webkit.org/show_bug.cgi?id=132945
          error.exception?.message !== 'Script error.',
      )
    }

    return payload
  })

  window.clientSideApmInstance = apm
}
